import { render } from "./KeywordView.vue?vue&type=template&id=1cde626d&scoped=true"
import script from "./_KeywordView.js?vue&type=script&lang=js&external"
export * from "./_KeywordView.js?vue&type=script&lang=js&external"

import "./_KeywordView.less?vue&type=style&index=0&id=1cde626d&lang=less&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cde626d"]])

export default __exports__